import { Link, useNavigate, useLocation } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import Logo from "../assets/optimized/PBSLogo.webp"; 

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <footer className="bg-[#1A150F] text-white pt-12 pb-6 px-6">
      {/* Outer flex to hold logo on left and content in center */}
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6">
        {/* Logo off to the side */}
        <div className="flex-shrink-0 mb-6 lg:mb-0">
          <img
            src={Logo}
            alt="PBS Logo"
            className="w-28 h-auto object-contain"
          />
        </div>

        {/* Main footer content (keeps grid layout untouched) */}
        <div className="flex-grow">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 border-b border-[#CC5500] pb-6">
            {/* Company Info */}
            <div>
              <h4 className="text-2xl font-bold mb-2">Pure Business Solutions</h4>
              <p className="text-sm text-gray-300">
                Empowering individuals and organizations through coaching, planning, and professional support.
              </p>
            </div>

            {/* PBS Links */}
            <div>
              <h5 className="text-xl font-semibold mb-2">PBS Links</h5>
              <ul className="space-y-1 text-sm flex flex-col">
                <Link to="/retreats" className="hover:underline hover:text-[#388B91]">Retreats & Conferences</Link>
                <Link to="/testimonials" className="hover:underline hover:text-[#388B91]">Our Testomonials</Link>
                <Link to="/coaching" className="hover:underline hover:text-[#388B91]">All Things Coaching</Link>
                              <Link
                to="/bookings"
                className="hover:underline hover:text-[#388B91]"
              >
                Book a Session
              </Link>
              </ul>
            </div>

            {/* Navigation */}
            <div className="flex flex-col">
              <h5 className="text-xl font-semibold mb-2">Quick Links</h5>
              <ul className="space-y-1 text-sm flex flex-col">
                <Link to="/" className="hover:underline hover:text-[#CC5500]">Home</Link>
                <Link to="/contact" className="hover:underline hover:text-[#CC5500]">Contact Us</Link>
                <Link to="/about" className="hover:underline hover:text-[#CC5500]">About Us</Link>
                <a onClick={() => navigate('/services', { state: { background: location } })} className="hover:underline hover:text-[#CC5500]">Services</a>
              </ul>
            </div>

            {/* Social Media */}
            <div className="flex flex-col">
              <h5 className="text-xl font-semibold mb-2">Social Media</h5>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/p/DKj7XtuNzzX/" className="hover:text-[#CC5500]">
                  <Instagram size={32} />
                </a>
                <a href="https://www.facebook.com/mauriceandkim4life42" className="hover:text-[#CC5500]">
                  <Facebook size={32} />
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h5 className="text-xl font-semibold mb-2">Contact</h5>
              <p className="text-sm text-gray-300">
                📍 2011 Fort Campbell Blvd. Clarksville, TN 37042<br />
                📞 (931) 561-7201<br />
                📧 mauriceandkim4life42@gmail.com
              </p>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="text-center pt-4 text-sm text-gray-400">
            © {new Date().getFullYear()} Pure Business Solutions. All rights reserved.
            <br />
            <span className="text-[#CC5500] font-semibold">
              Powered by <a href="https://mb-techs.com">MB-Techs LLC</a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
